/**
 * Routes on which the JWT-tied session refresh fires SILENTLY (no modal).
 * These are pages where users are mid-task (search-to-book flow + operational
 * queues / view-booking) and shouldn't be interrupted by a logout modal.
 *
 * The idle modal is NOT exempt — it shows on every page including these.
 *
 * Matches by prefix (case-insensitive) so sub-routes are covered
 * (e.g. /search/result/:id, /Orders/Invoice/:id, etc.).
 */
export const SILENT_REFRESH_ROUTE_PREFIXES = [
  "/search",
  "/booking/validate",
  "/orders/viewbooking",
  "/queues",
];

/**
 * Returns true if the given pathname is one of the routes that should
 * silently refresh the JWT without showing the "session about to expire" modal.
 */
export const isSilentRefreshRoute = (pathname) => {
  if (!pathname) return false;
  const normalized = pathname.toLowerCase();
  return SILENT_REFRESH_ROUTE_PREFIXES.some((prefix) => {
    const p = prefix.toLowerCase();
    return normalized === p || normalized.startsWith(`${p}/`);
  });
};